export default __webpack_public_path__ + "static/16-644ac31751a2865f59bd0c99147af63b.png";